export const BREADCRUMBS = {
  ACCESSORIES: 'accessories',
  APPAREL: 'apparel',
  ART: 'art',
  BAGS: 'bags',
  BRAND: 'brand',
  CALENDAR: 'calendar',
  COLLECTIBLES: 'collectibles',
  FOOTER: 'footer',
  HOME: 'home',
  HOMEPAGE: '/',
  INSTANT: 'instant',
  JEWELRY: 'jewelry',
  MEDIA: 'media',
  NAVIGATION: 'navigation',
  OTHER: 'other',
  OBJECTS: 'objects',
  SILHOUETTE: 'silhouette',
  SNEAKERS: 'sneakers',
  SPACE: 'space',
  TIMELINE: 'timeline',
  SPORTS: 'sports',
};
